
import WeatherApi from './src/WeatherApi'
import UniformConfigApi from './src/UniformConfigApi'
import EnvironmentApi from './src/EnvironmentApi'

let apis = {
   WeatherApi,
   EnvironmentApi,
   UniformConfigApi
};

export default apis;